import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/dellymanlogo.svg'


const _hoisted_1 = { class: "bg-[#690722] z-10 fixed w-full top-0" }
const _hoisted_2 = { class: "mx-auto max-w-7xl px-2 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "relative flex h-[6.5rem] items-center justify-between" }
const _hoisted_4 = { class: "absolute inset-y-0 left-0 flex items-center sm:hidden" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "block h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: "1.5",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "hidden h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: "1.5",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-1 items-center justify-center sm:items-stretch sm:justify-between text-[14px]\"><div class=\"flex flex-shrink-0 items-center\"><img class=\"\" src=\"" + _imports_0 + "\" alt=\"Company\" width=\"140\" height=\"80\"></div><div class=\"hidden sm:ml-6 sm:block flex my-auto\"><div class=\"flex space-x-4 font-[500]\"><ul><li><a href=\"https://dellyman.com\">Home</a></li><li><a href=\"/#agents\" class=\"w-[140px]\">Delivery Agents</a></li><li><a href=\"/#partners\" class=\"w-[150px]\">Anchor Partners</a></li><li><a href=\"/#collectionAgents\" class=\"w-[200px]\">Collection Agents</a></li><li class=\"mr-2\"><a href=\"/signup\" class=\"p-0\"><button class=\"bg-yellow-400 !border-2 w-[190px] rounded-full text-red-900 border-none py-2 cursor-pointer font-bold hover:bg-none hover:border-2 hover:border-white hover:text-white\"> Become a Partner </button></a></li></ul></div></div></div>", 1)
const _hoisted_9 = { class: "block sm:hidden" }
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"sm:hidden\"><li><a href=\"https://dellyman.com\">Home</a></li><li><a href=\"/#agents\" class=\"w-[140px]\">Delivery Agents</a></li><li><a href=\"/#partners\" class=\"w-[fit-content]\">Anchor Partners</a></li><li class=\"mr-2 mt-2\"><a href=\"/signup\" class=\"p-0\"><button class=\"bg-yellow-400 !border-2 w-[190px] rounded-full text-red-900 border-none py-2 cursor-pointer font-bold hover:bg-none hover:border-2 hover:border-white hover:text-white\"> Become a Partner </button></a></li></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
            "aria-controls": "mobile-menu",
            "aria-expanded": "false",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openSidebar && _ctx.openSidebar(...args)))
          }, [
            _createElementVNode("span", {
              class: "absolute -inset-0.5",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSidebar && _ctx.openSidebar(...args)))
            }),
            _hoisted_5,
            _hoisted_6,
            _hoisted_7
          ])
        ]),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: "w-sidebar w3-bar-block w3-collapse w3-card slide-enter-active slide-leave-active",
        style: _normalizeStyle(`width: ${_ctx.sidebarDisplay ? '238px' : '0px'}; display: ${
          _ctx.sidebarDisplay ? 'block' : ''
        }`),
        id: "mySidebar"
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "w3-bar-item !w-[fit-content] !inline-block w3-hide-large text-[27px] font-extrabold",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args)))
          }, " × ")
        ]),
        _hoisted_11
      ], 4)
    ])
  ]))
}